export enum ApplicationModules {
  FanManagement = 1,
  TicketShop = 2,
  Distributix = 3,
  MobileTicketing = 4,
  Merchandise = 5,
  Marketplace = 6, 
  RecurringMemberships = 7
}
